import React, { useState } from 'react';
import { Check } from 'lucide-react';

export const Newsletter: React.FC = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = () => {
    // Trigger success state. The form targets the iframe which remains in the DOM.
    setIsSubmitted(true);
  };

  return (
    <section className="py-24 bg-black border-t border-white/5 relative overflow-hidden">
      {/* Decorative background element */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] bg-brand-500/5 rounded-full blur-[120px] pointer-events-none"></div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center gap-12 bg-zinc-900/30 border border-white/5 p-8 md:p-16 rounded-2xl backdrop-blur-sm shadow-[0_30px_60px_rgba(0,0,0,0.4)]">
          <div className="w-full md:w-1/2 text-center md:text-left">
            <span className="text-brand-500 font-display font-bold uppercase tracking-[0.3em] text-[10px] mb-4 block">Exclusive Offer</span>
            <h2 className="text-4xl font-display font-bold uppercase text-white mb-4">10% Off + <span className="text-outline-brand">Content Blueprint</span></h2>
            <p className="text-zinc-400 text-sm font-light leading-relaxed">
              Get an instant discount on your shoot and the 20-pillar guide to never running out of social media ideas again.
            </p>
          </div>

          <div className="w-full md:w-1/2 min-h-[220px] flex flex-col justify-center relative">
            <form 
              action="https://acumbamail.com/newform/subscribe/9zPhp2UIUQgtlakxXzdSjA6Jj4mZQ/60965/?iframe=1" 
              target="acm_result_60965" 
              method="post" 
              className={`flex flex-col gap-4 transition-all duration-500 ${isSubmitted ? 'opacity-0 pointer-events-none scale-95 absolute inset-0' : 'opacity-100'}`}
              onSubmit={handleSubmit}
            >
              <div className="relative group">
                <input 
                  id="r0c0m1r1f1" 
                  name="email_1" 
                  type="email" 
                  required 
                  autoComplete="email"
                  placeholder="Your Email Address"
                  className="w-full bg-black/50 border border-white/10 px-6 py-4 rounded-sm text-white focus:outline-none focus:border-brand-500 transition-all font-sans text-sm placeholder:text-zinc-600"
                />
                
                {/* Honeypot fields to protect against spam */}
                <input type="text" name="a1179207c" tabIndex={-1} defaultValue="" style={{ position: 'absolute', left: '-4900px' }} aria-hidden="true" id="a1179207c" autoComplete="off"/>
                <input type="email" name="b1179207c" tabIndex={-1} defaultValue="" style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true" id="b1179207c" autoComplete="off"/>
                <input type="checkbox" name="c1179207c" tabIndex={-1} style={{ position: 'absolute', left: '-5100px' }} aria-hidden="true" id="c1179207c" autoComplete="off"/>
              </div>

              <input type="hidden" name="ok_redirect" id="id_redirect" value="" />
              
              <button 
                type="submit" 
                className="w-full h-14 bg-brand-500 text-black font-display font-bold uppercase tracking-widest hover:bg-white transition-all duration-300"
              >
                Claim My Discount
              </button>
            </form>

            {/* Always keep the iframe in the DOM so the form submission target is valid */}
            <iframe 
              name="acm_result_60965" 
              id="acm_result_60965" 
              title="Subscription result" 
              className="hidden"
              loading="lazy" 
              referrerPolicy="strict-origin-when-cross-origin"
            ></iframe>

            {isSubmitted && (
              <div className="flex flex-col items-center text-center p-8 bg-brand-500/5 border border-brand-500/20 rounded-xl animate-in fade-in zoom-in duration-700">
                <div className="w-16 h-16 bg-brand-500/10 rounded-full flex items-center justify-center mb-6 text-brand-500">
                  <Check size={32} />
                </div>
                <h3 className="text-xl font-display font-bold uppercase text-white mb-4 tracking-wider">Subscription Pending</h3>
                <p className="text-zinc-300 text-sm font-light leading-relaxed">
                  Please check your email and confirm your subscription to receive your benefits.
                </p>
                <button 
                  onClick={() => setIsSubmitted(false)}
                  className="mt-6 text-[10px] font-bold uppercase tracking-[0.2em] text-zinc-600 hover:text-brand-500 transition-colors"
                >
                  Submit another email
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};